import { render, staticRenderFns } from "./quote-mta.vue?vue&type=template&id=01c7e74b&scoped=true"
import script from "./quote-mta.vue?vue&type=script&lang=js"
export * from "./quote-mta.vue?vue&type=script&lang=js"
import style0 from "./quote-mta.vue?vue&type=style&index=0&id=01c7e74b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c7e74b",
  null
  
)

export default component.exports